import { combineEpics } from 'redux-observable';

import checkOnLoginEpic from './checkOnLogin.epic';

export default combineEpics(checkOnLoginEpic);
